import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import MobileNav from "./MobileNav";

export default function Layout({ children, hideFooter = false }) {
  return (
    <div id="layout_main" className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-16 lg:pt-20 pb-16 lg:pb-0">
        {children}
      </main>
      <div
        className={`transition-opacity duration-300 ${
          hideFooter ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
      >
        <Footer />
      </div>
      <MobileNav />
    </div>
  );
}
